import Vue from "vue";
import Vuex from "vuex";
import aiTranslate from "./ai_translate.js";
import aiWrite from "./ai_write/index.js";
import aisearch from "./aisearch.js";
import aiWriteHistory from "./ai_write_history/index.js";
import gamebox from "./Gamebox/index.js";
import aiChat from "./ai_chat/index.js";
Vue.use(Vuex);

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    customAppGuideRegedit: true, // 自定义引导页注册表
    removeCustomApp: "", // 侧边栏被移除的应用
    surveyJsUrl: "",
    aiStickVersion: null,
    isLogin: null,
    isAIStick: null,
    loginInfo: null,
    networkError: null,
    aiWindowStatus: false, // 页面展开/收起状态
    notifyActionType: "", // 通知执行动作（提问 ask、搜索 search、翻译 translate、润色 polish、续写 continue、总结 summarize）
    notifyActionContent: "", // 通知执行内容
    notifyActionFrom: '', // 来源：1、点击去翻译后展开的；2、右下角弹窗调起AI翻译（不带内容推送）3、侧栏弹泡 4、点击结果页返回按钮 5、点击划词里的翻译
    notifyActionTargetLanguage: '', // 弹窗&弹泡策略，目标语言
  },
  getters: {},
  mutations: {
    setCustomAppGuideRegedit(state, payload) {
      state.customAppGuideRegedit = payload;
    },
    setRemoveCustomApp(state, payload) {
      state.removeCustomApp = payload;
    },
    setSurveyJsUrl(state, payload) {
      state.surveyJsUrl = payload;
    },
    setAiStickVersion(state, payload) {
      state.aiStickVersion = payload;
    },
    setIsLogin(state, payload) {
      state.isLogin = payload;
    },
    setIsAIStick(state, payload) {
      state.isAIStick = payload;
    },
    setLoginInfo(state, payload) {
      if (payload.lenovoid) {
        payload.loginid = payload.lenovoid;
      }
      state.loginInfo = payload;
    },
    setNetworkError(state, payload) {
      state.networkError = payload;
    },
    updataAiWindowStatus(state, payload) {
      state.aiWindowStatus = payload;
    },
    updateNotifyActionType(state, payload) {
      state.notifyActionType = payload;
    },
    updateNotifyActionContent(state, payload) {
      state.notifyActionContent = payload;
    },
    updateNotifyActionFrom(state, payload) {
      state.notifyActionFrom = payload;
    },
    updateNotifyActionTargetLanguage(state, payload) {
      state.notifyActionTargetLanguage = payload;
    },
  },
  actions: {},
  modules: {
    aiTranslate,
    aiWrite,
    aisearch,
    gamebox,
    aiWriteHistory,
    aiChat,
  },
});
